export default __webpack_public_path__ + "static/25-10f905704a35bb9fe92c4f4d1e15bf6f.webp";